export default "__VITE_ASSET__1edd9171__"